<template>
  <div class="animated fadeIn">
    <div class="card shadow-sm border-0" v-if="payroll">
      <div class="card-header bg-dark text-white d-flex align-items-center justify-content-between py-2">
        <h6 class="mb-0"><font-awesome-icon icon="list" /> Office Payroll #{{ payroll.id }} <b-badge variant="light" class="text-dark ml-1" v-if="payroll.payroll_group">{{ payroll.payroll_group.name }}</b-badge></h6>
        <div>
          <a :href="$router.resolve({ name: 'Office Payslip', params: { id: payroll.id } }).href" target="_blank" rel="noopener noreferrer">
            <b-button variant="primary" size="sm" class="mr-2"><font-awesome-icon icon="print" /> Print Payslips</b-button>
          </a>
          <b-button variant="light" size="sm" @click="$router.push('/manpowers/office-payroll')">
            <font-awesome-icon icon="chevron-left" /> Back
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <b-row class="mb-3">
          <b-col md="3"><small class="text-muted">Period</small><div class="font-weight-bold">{{ payroll.date_from.other_formats.format_1 }} &mdash; {{ payroll.date_to.other_formats.format_1 }}</div></b-col>
          <b-col md="3"><small class="text-muted">Voucher #</small><div class="font-weight-bold">{{ payroll.voucher_number || '-' }}</div></b-col>
          <b-col md="3"><small class="text-muted">Check #</small><div class="font-weight-bold">{{ payroll.check_number || '-' }}</div></b-col>
          <b-col md="3"><small class="text-muted">Authorized By</small><div class="font-weight-bold">{{ payroll.authorized ? payroll.authorized.name : '-' }}</div></b-col>
        </b-row>

        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead class="thead-light text-center">
              <tr>
                <th rowspan="2" class="align-middle text-left">Employee</th>
                <th colspan="3">Hours</th>
                <th rowspan="2" class="align-middle">Days</th>
                <th rowspan="2" class="align-middle text-right">Cost</th>
                <th rowspan="2" class="align-middle text-right">CA Balance</th>
                <th colspan="5">Deductions</th>
                <th rowspan="2" class="align-middle text-right">Total Payout</th>
              </tr>
              <tr>
                <th>Reg</th><th>OT</th><th>ND</th>
                <th>CA</th><th>SSS</th><th>PhilHealth</th><th>Pag-IBIG</th><th>Others</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, i) in payroll.office_payroll_details" :key="i">
                <td class="text-nowrap">{{ d.manpower ? d.manpower.full_name : '' }}</td>
                <td class="text-center">{{ d.total_regular_hours }}</td>
                <td class="text-center">{{ d.total_ot_hours }}</td>
                <td class="text-center">{{ d.total_nd_hours }}</td>
                <td class="text-center">{{ d.total_days }}</td>
                <td class="text-right">{{ money(d.initial_payout) }}</td>
                <td class="text-right">{{ money(d.previous_ca_balance) }}</td>
                <td class="text-right">{{ money(d.ca_payment) }}</td>
                <td class="text-right">{{ money(d.sss_payment) }}</td>
                <td class="text-right">{{ money(d.philhealth_payment) }}</td>
                <td class="text-right">{{ money(d.pagibig_payment) }}</td>
                <td class="text-right">{{ money(d.other_payment) }}</td>
                <td class="text-right font-weight-bold">{{ money(d.total_payout) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-dark text-white font-weight-bold">
                <td colspan="12" class="text-right">Grand Total</td>
                <td class="text-right">{{ money(grandTotal) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SwalMixin from '@/views/mixins/Swal.js'

  export default {
    name: 'OfficePayrollView',
    mixins: [SwalMixin],
    data() {
      return { payroll: null }
    },
    computed: {
      grandTotal() {
        if (!this.payroll) return 0;
        return this.payroll.office_payroll_details.reduce((t, d) => t + Number(d.total_payout || 0), 0);
      }
    },
    created() {
      this.get();
    },
    methods: {
      money(value) {
        const n = Number(value);
        if (isNaN(n)) return value;
        return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      get() {
        this.axios.get('office-payroll/get', { params: { id: this.$route.params.id } })
          .then(response => { this.payroll = response.data; })
          .catch(error => {
            this.swal_transaction_error_data.text = (error.response && error.response.data) ? error.response.data : 'Something went wrong.';
            this.swalRequestError();
          });
      }
    }
  }
</script>
